module.exports = __webpack_public_path__ + "static/media/syrine.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/designer-profiles/syrine.png
// module id = 523
// module chunks = 0